// ---------------------------------------------------------------------------
// Guidebook — Shared SVG Icons
// ---------------------------------------------------------------------------

// Navigation icons (extracted from QuickLinks)
export function WaveIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M2 10c2-3 4-3 6 0s4 3 6 0" />
    </svg>
  )
}

export function InfoIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="8" cy="8" r="6" />
      <path d="M8 7v4M8 5.5v0" />
    </svg>
  )
}

export function WifiIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M2 6a9.5 9.5 0 0 1 12 0M4.5 9a5.5 5.5 0 0 1 7 0" />
      <circle cx="8" cy="12" r="1" fill="currentColor" stroke="none" />
    </svg>
  )
}

export function KeyIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="5.5" cy="6.5" r="3" />
      <path d="M8 8.5l5 5M11 11.5l2-2" />
    </svg>
  )
}

export function CalIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <rect x="2" y="3" width="12" height="11" rx="1.5" />
      <path d="M2 6.5h12M5 1.5v3M11 1.5v3" />
    </svg>
  )
}

export function RulesIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M8 2L2 5.5v5.5L8 14l6-3V5.5L8 2z" />
      <path d="M6 8l2 2 3-3" />
    </svg>
  )
}

export function PlacesIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="8" cy="6.5" r="2" />
      <path d="M8 14s-4.5-4-4.5-7.5a4.5 4.5 0 1 1 9 0C12.5 10 8 14 8 14z" />
    </svg>
  )
}

export function WeatherIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="6.5" cy="6" r="3" />
      <path d="M9.5 6a3 3 0 0 1 0 6H4" />
      <path d="M3.5 12a2 2 0 0 1 0-4" />
    </svg>
  )
}

export function EmergencyIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M6 2h4l1 4-3 2-3-2 1-4z" />
      <path d="M3 10l5 4 5-4" />
    </svg>
  )
}

// Utility icons
export function ChevronDownIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9l6 6 6-6" />
    </svg>
  )
}

export function CloseIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M4 4l8 8M12 4l-8 8" />
    </svg>
  )
}

export function ArrowUpIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M8 13V3M4 7l4-4 4 4" />
    </svg>
  )
}
